import { render, staticRenderFns } from "./AtosAdministrativosPorEnteFederativoPorAno.vue?vue&type=template&id=f632c544&scoped=true"
import script from "./AtosAdministrativosPorEnteFederativoPorAno.vue?vue&type=script&lang=js"
export * from "./AtosAdministrativosPorEnteFederativoPorAno.vue?vue&type=script&lang=js"
import style0 from "./AtosAdministrativosPorEnteFederativoPorAno.vue?vue&type=style&index=0&id=f632c544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f632c544",
  null
  
)

export default component.exports